import { normalizarTexto, tieneCaracteresInvalidos } from "../../../utilities/textValidations.js";

export { normalizarTexto, tieneCaracteresInvalidos };

export const obtenerTipoTexto = (tipoProducto) =>
  typeof tipoProducto === "string" ? tipoProducto : tipoProducto?.descripcion || "";

export const esMetrajeValido = (metraje) => {
  const metrajeNum = parseFloat(metraje);
  return !isNaN(metrajeNum) && metrajeNum > 0;
};

export const existeProductoDuplicado = (productos, descripcion, tipoProducto) => {
  const descNormalized = normalizarTexto(descripcion);
  const tipoNormalized = obtenerTipoTexto(tipoProducto).trim().toLowerCase();

  return productos.some((p) => {
    const pDesc = normalizarTexto(p.descripcion);
    const pTipo = obtenerTipoTexto(p.tipoProducto).trim().toLowerCase();
    return pDesc === descNormalized && pTipo === tipoNormalized;
  });
};
